import React, { useState } from 'react';
import { CalendarClock, X, Calendar, Check, Loader2 } from 'lucide-react';

const ExtensionRequestModal = ({
    isOpen,
    onClose,
    selectedSection,
    editableData,
    extensionDate,
    setExtensionDate,
    extensionNotes,
    setExtensionNotes,
    isUpdating,
    handleRequestExtension,
    toDMY
}) => {
    const [showError, setShowError] = useState(false);

    if (!isOpen) {
        if (showError) setShowError(false);
        return null;
    }
    return (
        <div className="ai-modal-overlay" style={{ zIndex: 10005 }}>
            <div className="ai-modal-content key-info-modal" style={{ maxWidth: '480px' }}>
                <div className="ai-modal-header">
                    <div className="ai-modal-title">
                        <CalendarClock size={20} color="#FF5526" />
                        <h3>Request Deadline Extension</h3>
                    </div>
                    <button className="modal-close-btn" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>
                <div className="ai-modal-body key-info-modal-body">
                    <div className="modal-row">
                        <div className="modal-field-group">
                            <label>CURRENT DEADLINE</label>
                            <div className="smart-date-wrapper" style={{ background: '#F1F5F9', opacity: 0.8 }}>
                                <div className="modal-input" style={{ color: '#64748B' }}>
                                    {(() => {
                                        const rawDate = selectedSection?.deadline || editableData?.PROPOSAL_DEADLINE || editableData?.proposal_deadline;
                                        if (!rawDate || rawDate === 'N/A') return 'No Deadline Set';
                                        return toDMY(rawDate);
                                    })()}
                                </div>
                            </div>
                        </div>

                        <div className="modal-field-group">
                            <label>REQUESTED DEADLINE</label>
                            <div className="smart-date-wrapper">
                                <input
                                    type="text"
                                    className="modal-input smart-input"
                                    value={extensionDate}
                                    onChange={(e) => setExtensionDate(e.target.value)}
                                    placeholder="DD-MM-YYYY"
                                />
                                <div
                                    className="calendar-trigger-wrapper"
                                    style={{ color: '#FF5526', cursor: 'pointer' }}
                                    onClick={(e) => e.currentTarget.querySelector('.hidden-native-picker')?.showPicker()}
                                >
                                    <Calendar size={16} className="calendar-icon-trigger" color="#FF5526" />
                                    <input
                                        type="date"
                                        className="hidden-native-picker"
                                        min={new Date().toISOString().split('T')[0]}
                                        onChange={(e) => setExtensionDate(toDMY(e.target.value))}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-field-group">
                        <label>REASON

                            <span style={{ color: '#ef4444', marginLeft: '4px' }}>*</span>
                        </label>
                        <textarea
                            className="modal-input-reason"
                            placeholder="Please explain why more time is needed..."
                            style={{
                                minHeight: '100px',
                                border: showError ? '1.5px solid #ef4444' : '1.5px solid #E2E8F0',
                                borderRadius: '12px',
                                background: '#F8F9FA',
                                padding: '0.8rem 1rem',
                                fontSize: '0.9rem',
                                resize: 'none',
                                width: '100%',
                                boxSizing: 'border-box',
                                outline: 'none',
                                color: '#1E293B',
                                transition: 'all 0.2s'
                            }}
                            value={extensionNotes}
                            onChange={(e) => {
                                setExtensionNotes(e.target.value);
                                if (showError) setShowError(false);
                            }}
                        />
                        {showError && (
                            <span style={{ color: '#ef4444', fontSize: '0.75rem', marginTop: '6px', display: 'block', fontWeight: 500 }}>
                                This field is required to request an extension.
                            </span>
                        )}
                    </div>
                </div>
                <div className="ai-modal-footer">
                    <button
                        className="secondary-action-btn"
                        onClick={onClose}
                        style={{
                            borderColor: '#FF5526',
                            color: '#FF5526'
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className="primary-action-btn"
                        onClick={async () => {
                            if (!extensionNotes || !extensionNotes.trim()) {
                                setShowError(true);
                                return;
                            }

                            const sectionId = selectedSection?.id || selectedSection?._id;
                            const parts = extensionDate.split('-');
                            const isoDate = parts.length === 3 ? `${parts[2]}-${parts[1]}-${parts[0]}` : extensionDate;

                            const success = await handleRequestExtension(sectionId, isoDate, extensionNotes);
                            if (success) {
                                onClose();
                                setExtensionDate('');
                                setExtensionNotes('');
                                setShowError(false);
                            }
                        }}
                        disabled={!extensionDate || isUpdating}
                        style={{
                            background: '#FF5526',
                            borderColor: '#FF5526',
                            color: 'white',
                            boxShadow: '0 4px 12px rgba(240, 74, 35, 0.2)'
                        }}
                    >
                        {isUpdating ? <Loader2 size={16} className="animate-spin" /> : <Check size={16} />}
                        <span>{isUpdating ? 'Submitting...' : 'Submit Request'}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExtensionRequestModal;
